import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=a4fe9caa&"
import script from "./chatItem.js?vue&type=script&lang=js&"
export * from "./chatItem.js?vue&type=script&lang=js&"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=a4fe9caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports